<template>
    <div class="search-form">
        <b-row align-h="between">
            <b-col cols="7">
                <b-form @reset="reset" onsubmit="return false">
                    <b-input-group size="sm">

                    </b-input-group>
                </b-form>
            </b-col>
        </b-row>
    </div>
</template>
<script>
// 初始表单
const initForm = {
    keyword: '',
    icechopsStatus: ['Y'],
}
export default {
    data(){
        return {
            advqueryDialogVisible: false,
            form: { ...initForm},
        }
    },
    created(){
        this.query()
    },
    methods: {
        fromLoad(val){
            this.$emit(val)
        },
        // 初始查询
		query({ isReset = true } = {}) {
			if (isReset) {
				this.$emit('reset')
			}
			this.$emit('query', this.form)
        },
        // 重置查询条件 - 高级查询
		reset() {
			this.form = { ...initForm }
		},
    }
}
</script>
<style lang="scss" scoped>
.el-form-item {
	margin-bottom: 0px;
}
.line {
	text-align: center;
}
</style>